module.exports = __webpack_public_path__ + "img/small-6.1f3c1e6e.webp";